import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  enrollmentCard: {
    position: 'relative',
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: '2rem 3.2rem',
    marginBottom: '3.6rem',
    '&:last-of-type': {
      marginBottom: '0',
    },
  },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '3.6rem' },
  leftHeaderSection: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' },
  rightHeaderSection: { position: 'relative' },
  effectiveDateWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    marginBottom: '0.5rem',
  },
  effectiveDateTitle: {
    font: { size: '1.6rem', lineHeight: '2.4rem', weight: 500 },
    letterSpacing: '0.05rem',
    color: colors.neutral[500],
    textTransform: 'uppercase',
    margin: 0,
  },
  effectiveDateValue: {
    font: {
      size: '2.4rem',
      lineHeight: '3.2rem',
      weight: 700,
    },
    letterSpacing: '0.02rem',
    margin: 0,
    color: colors.neutral[900],
    minWidth: '13.2rem',
    marginRight: '2rem',
  },
  stageTagContainer: {
    paddingBottom: '0.3rem',
  },
  expirationReminder: {
    margin: 0,
    position: 'absolute',
    top: '4rem',
    right: '0rem',
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 600,
      style: 'italic',
    },
    letterSpacing: '0.02rem',
    textAlign: 'right',
    color: colors.red[500],
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  cardHeaderWithoutDate: {
    margin: '1rem 0 2rem',
  },
  soldButtonsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '1rem',
  },
  actionButton: {
    textTransform: 'uppercase',
    fontWeight: 700,
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
